import { ApexOptions } from "apexcharts";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import apiClient from "../../../lib/apis/fetch";
import { setCookie, getCookie } from "../../../lib/utils/cookies";
import { getRouteSegment } from "../../../lib/utils/funcs";

export default function BarGraph({ type, doctor_id }: { type: any; doctor_id?: string | undefined }) {
  const bookingOverviewCookie = getCookie("bookingOverview");
  const dailyOverviewCookie = getCookie("dailyOverview");

  const defaultBookingData = { monthly_bookings: [], no_shows: [] };
  const defaultDailyData = { daily_counts: [] };

  const [myData, setMyData] = useState(
    bookingOverviewCookie
      ? JSON.parse(bookingOverviewCookie)
      : defaultBookingData
  );
  const [dailyData, setDailyData] = useState(
    dailyOverviewCookie ? JSON.parse(dailyOverviewCookie) : defaultDailyData
  );
  useEffect(() => {
    const bookingCookie = getCookie("bookingOverview");
    const dailyCookie = getCookie("dailyOverview");
    if (bookingCookie) {
      try {
        setMyData(JSON.parse(bookingCookie));
      } catch (error) {
        console.error("Error parsing bookingOverview cookie", error);
      }
    }
    if (dailyCookie) {
      try {
        setDailyData(JSON.parse(dailyCookie));
      } catch (error) {
        console.error("Error parsing dailyOverview cookie", error);
      }
    }
  }, [bookingOverviewCookie, dailyOverviewCookie]);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Chart state recalculated on every render
  const chartState = {
    series: [
      {
        name: "No show",
        data:
          String(type) === "daily"
            ? dailyData.daily_counts.map((item: any) => parseInt(item.no_shows))
            : myData.no_shows.map((item: any) => parseInt(item.no_shows)),
      },
      {
        name: "Show",
        data:
          String(type) === "daily"
            ? dailyData.daily_counts.map((item: any) => parseInt(item.bookings) - parseInt(item.no_shows))
            : myData.monthly_bookings.map((item: any, index: number) =>
                parseInt(item.total_bookings) - parseInt(myData.no_shows[index].no_shows)
              ),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories:
          String(type) === "daily"
            ? dailyData.daily_counts.map((item: any) => {
                const monthYear = item.day.split("/");
                const monthIndex = parseInt(monthYear[1]) - 1;
                return parseInt(monthYear[0]) + " " + monthNames[monthIndex];
              })
            : myData.monthly_bookings.map((item: any) => {
                const monthYear = item.month.split("/");
                const monthIndex = parseInt(monthYear[0]) - 1;
                return monthNames[monthIndex];
              }),
      },
      fill: {
        opacity: 1,
      },
    } as ApexOptions,
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartState.options}
          series={chartState.series}
          type="bar"
          height={350}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
}
